import { clsx } from "clsx";
import type { ChatUserBrief } from "../types";

interface AvatarProps {
  user: Pick<ChatUserBrief, "full_name" | "username" | "profile_picture_url"> | null;
  size?: number;
  className?: string;
}

function initials(user: AvatarProps["user"]): string {
  if (!user) return "?";
  const source = user.full_name?.trim() || user.username || "";
  const parts = source.split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0][0]?.toUpperCase() ?? "?";
  return `${parts[0][0] ?? ""}${parts[1][0] ?? ""}`.toUpperCase();
}

export function Avatar({ user, size = 32, className }: AvatarProps) {
  const px = `${size}px`;
  if (user?.profile_picture_url) {
    return (
      <img
        src={user.profile_picture_url}
        alt={user.full_name || user.username}
        style={{ width: px, height: px }}
        className={clsx("rounded-full object-cover flex-shrink-0", className)}
      />
    );
  }
  return (
    <div
      style={{ width: px, height: px, fontSize: Math.max(10, size * 0.4) }}
      className={clsx(
        "rounded-full bg-amber-100 text-amber-700 font-mono font-semibold flex items-center justify-center flex-shrink-0 select-none",
        className,
      )}
    >
      {initials(user)}
    </div>
  );
}
